import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  timeout: 30000,
});

export const fetchBlogs = async () => {
  const { data } = await apiClient.get('/blogs');
  return data;
};

export const fetchBlog = async (slug) => {
  const { data } = await apiClient.get(`/blogs/${slug}`);
  return data;
};

export const fetchWinnersToday = async () => {
  const { data } = await apiClient.get('/winners/today');
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await apiClient.post('/contact', payload);
  return data;
};

export const submitTestScan = async (payload) => {
  const { data } = await apiClient.post('/scans', payload);
  return data;
};

export const triggerBlogGenerate = async () => {
  const { data } = await apiClient.post('/blogs/generate');
  return data;
};
